// export const API_URL = 'https://api.retteweb.eu'
// export const API_URL = 'http://localhost:8000'
export const API_URL = 'https://api.staging.retteweb.eu'

export const FRONTEND_URL = 'https://staging.retteweb.eu'

export const LAST_YEAR = '2025-2026'
